import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgArrowUp = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="none" viewBox="0 0 25 25" {...props}><Path fill="currentColor" d="M12.5 0 2.2 10.1 4.1 12l7-7v20h2.8V5l7 7 1.9-1.9z" /></Svg>;
const Memo = memo(SvgArrowUp);
export default Memo;